// CheckoutForm.js
import React from 'react';
import { injectStripe } from 'react-stripe-elements';
import CardSection from './CardSection';
import InjectedPaymentRequest from './PaymentRequest';
import cn from 'classnames';
import { navigate } from 'gatsby-link';

class CheckoutForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      amount: 0,
      isLoading: false,
      hidden: true,
      csrf: false,
      name: false,
      location: 'Onehunga',
      amountInputFocused: false,
      error: false,
    };
    this.ammountRef = React.createRef();
    this.ammountRef = React.createRef();

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (ev) => {
    this.setState({ [ev.target.name]: ev.target.value });
  };

  handleAmount = (ev) => {
    this.setState({ [ev.target.name]: parseInt(ev.target.value) });
  };

  toggleAmount = (ev) => {
    this.setState({ amount: 0, hidden: false });
    this.ammountRef.current.focus();
  };

  amountClick = (ev) => {
    console.log(ev.target.value);
    this.setState({ amount: parseFloat(ev.target.value), hidden: false });
  };

  handleSubmit = (ev) => {
    ev.preventDefault();

    let location = this.state.location;
    let amount = this.state.amount;
    if (amount) {
      amount = amount * 100; //convert to cents
      this.setState({ error: false });
    } else {
      this.setState({ error: 'Donation must be greater than $1.00' });
      this.ammountRef.current.focus();
      return;
    }

    this.props.stripe
      .createToken({ type: 'card', name: this.state.name || 'Anonymous Donor' })
      .then((result) => {
        if (result.error) {
          throw result.error.message;
        }
        let token = result.token;
        this.setState({ isLoading: true });
        fetch(`${process.env.GATSBY_LAMBDA_ENDPOINT}payment`, {
          method: 'POST',
          body: JSON.stringify({
            token,
            charge: {
              amount: amount,
              currency: 'nzd',
              location: location,
            },
          }),
        })
          .then((response) => response.json())
          .catch((error) => console.error(error))
          .then((response) => {
            if (response !== undefined && response.hasOwnProperty('charge')) {
              navigate('/confirmation', {
                state: { amount: this.state.amount },
              });
            } else if (response) {
              this.setState({ error: response.error });
              this.setState({ isLoading: false });
            } else {
              this.setState({ isLoading: false });
            }
          });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  render() {
    return (
      <div>
        <p className="mb-2 text-xs">Amount you would like to pay</p>
        <ul className="-mx-1 mb-6 pt-1 list-reset flex">
          <li className="px-1 flex-1">
            <button
              className={cn(
                'bg-grey text-sm rounded-full w-full h-16 focus:bg-grey focus:outline-none',
                {
                  'bg-grey-light': this.state.amount !== 10,
                }
              )}
              onClick={this.amountClick}
              value="10"
            >
              $10
            </button>
          </li>
          <li className="px-1 flex-1">
            <button
              className={cn(
                'bg-grey text-sm rounded-full w-full h-16 focus:bg-grey focus:outline-none',
                {
                  'bg-grey-light': this.state.amount !== 20,
                }
              )}
              onClick={this.amountClick}
              value="20"
            >
              $20
            </button>
          </li>
          <li className="px-1 flex-1">
            <button
              className={cn(
                'bg-grey text-sm rounded-full w-full h-16 focus:bg-grey focus:outline-none',
                {
                  'bg-grey-light': this.state.amount !== 50,
                }
              )}
              onClick={this.amountClick}
              value="50"
            >
              $50
            </button>
          </li>
          <li className="px-1 flex-1">
            <button
              className={cn(
                'bg-grey text-sm rounded-full w-full h-16 focus:bg-grey focus:outline-none',
                {
                  'bg-grey-light': this.state.amount !== 100,
                }
              )}
              onClick={this.amountClick}
              value="100"
            >
              $100
            </button>
          </li>
          <li className="px-1 flex-1">
            <button
              className="
                bg-grey-light text-sm rounded-full w-full h-16 focus:bg-grey focus:outline-none
              "
              onClick={this.toggleAmount}
            >
              Other
            </button>
          </li>
        </ul>
        <form onSubmit={this.handleSubmit} className="text-xs text-black">
          <label
            htmlFor="amount"
            className={cn('overflow-hidden checkout_amount block', {
              'is-hidden': this.state.hidden,
            })}
          >
            Donation
            <div>
              <input
                type="number"
                id="amount"
                placeholder="Amount (NZD)"
                name="amount"
                className="text-input"
                value={this.state.amount}
                onChange={(ev) => this.handleAmount(ev)}
                onFocus={() => this.setState({ amountInputFocused: true })}
                onBlur={() => this.setState({ amountInputFocused: false })}
                ref={this.ammountRef}
              />
            </div>
          </label>
          <label htmlFor="name" className="mt-6 block">
            Name
            <div>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Name (Optional)"
                className="text-input"
                onChange={(ev) => this.handleChange(ev)}
              />
            </div>
          </label>
          <label htmlFor="location" className="mt-6 block">
            Which location did you dine at?
            <div className="mt-2 relative">
              <select
                className="block appearance-none w-full bg-white border hover:border-grey-dark px-4 py-2 pr-8 rounded leading-tight focus:outline-none focus:border-grey-dark text-sm"
                name="location"
                id="location"
                value={this.state.location}
                onChange={(ev) => this.handleChange(ev)}
              >
                <option value="Glenn Innes">Glen Innes</option>
                <option value="Onehunga">Onehunga</option>
                <option value="Wellington">Wellington</option>
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg
                  className="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
              </div>
            </div>
          </label>
          <CardSection />
          <p className={cn('mt-2 text-red', { hidden: !this.state.error })}>
            {this.state.error}
          </p>
          <div className="mt-10">
            <div className="relative mb-2">
              <button
                className={cn('btn btn-primary w-full', {
                  'text-transparent': this.state.isLoading,
                })}
              >
                Pay
              </button>
              <div
                className={cn(
                  'absolute lds-ring pointer-events-none opacity-0',
                  {
                    'opacity-100': this.state.isLoading,
                  }
                )}
              >
                <div />
                <div />
                <div />
                <div />
              </div>
            </div>
            {!this.state.amountInputFocused ? (
              <InjectedPaymentRequest amount={this.state.amount} />
            ) : null}
          </div>
        </form>
      </div>
    );
  }
}

export default injectStripe(CheckoutForm);
